(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;
    const { Fragment } = wp.element;
    const { SelectControl, TextControl, PanelBody, PanelRow } = wp.components;
    if (typeof wp.blockEditor != "undefined") var { InspectorControls } = wp.blockEditor;
    else var { InspectorControls } = wp.editor;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-authorization-gutenberg-block', {

        // Block setup
        title: __('Discord Authorization Button', 'discord-wordpress-plugin'),
        description: __('Block outputs an HTML link for authorization with Discord profile.', 'discord-wordpress-plugin'),
        icon: <svg width="430" height="430" viewBox="0 0 430 430">
                <path fill="#72daaa" d="M0 40.1111V320.889C0 342.95 17.8494 361 40.1111 361H320.889C342.95 361 361 342.95 361 320.889V40.1111C361 18.05 342.95 0 320.889 0H40.1111C17.8494 0 0 18.05 0 40.1111ZM240.667 120.333C240.667 153.626 213.792 180.5 180.5 180.5C147.208 180.5 120.333 153.626 120.333 120.333C120.333 87.0411 147.208 60.1667 180.5 60.1667C213.792 60.1667 240.667 87.0411 240.667 120.333ZM60.1667 280.778C60.1667 240.667 140.389 218.606 180.5 218.606C220.611 218.606 300.833 240.667 300.833 280.778V300.833H60.1667V280.778Z"/>
                <rect x="238" y="238" width="177" height="145" fill="white"/>
                <path fill="#7289DA" d="M355.17,317.14a10.72,10.72,0,0,1-10.69,10.71,11.06,11.06,0,0,1-7.62-3.18,10.3,10.3,0,0,1-3.07-7.45,10.72,10.72,0,0,1,10.69-10.71v0A10.66,10.66,0,0,1,355.17,317.14Zm-47.47-10.67,0,0A10.72,10.72,0,0,0,297,317.21a10.3,10.3,0,0,0,3.07,7.45,11.06,11.06,0,0,0,7.62,3.18,10.69,10.69,0,0,0,0-21.38ZM430,237.17V430l-25.28-20.36-13.83-12-15.15-12.52L382,404.88H249.65c-13.21,0-24-9.57-24-22.17V237.22c0-12,10.74-22.17,24-22.17l155.72,0C418.66,215,429.34,225.18,430,237.17ZM347.27,266l.32-.09h-.23Zm49.49,74.23c0-34.65-17.13-62.87-17.13-62.87-15.32-10.8-29.62-11.28-32.32-11.28l-1.74,1.63c19.56,5.38,29,13.76,29,13.76a109.65,109.65,0,0,0-87.07-3.61c-4.43,1.81-6.95,3-6.95,3s9.42-9,30.26-13.76l-1.28-1.19s-15.82-.57-32.82,11.37c0,0-17.05,28.13-16.89,63,0,0,9.42,15.61,35.29,16.18,0,0,3.75-4.81,7.59-9-14.54-4.19-20.2-12.57-20.2-12.57l4.85,2.38c14.21,5.55,29.25,12.56,56,8.37,5.62-1.23,11.29-2.42,17-4.8,3.67-1.81,8.19-3.61,13.17-6.61,0,0-5.65,8.38-20.79,12.57,3.11,4.19,7.5,9,7.5,9C386.16,355.19,396.22,339.61,396.77,340.24Z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            loginText: {
                type: 'string',
                default: __('Login with Discord', 'discord-wordpress-plugin'),
            },
            logoutText: {
                type: 'string',
                default: __('Logout', 'discord-wordpress-plugin'),
            },
            styling: {
                type: 'string',
                default: 'no',
            },
            redirectTo: {
                type: 'string',
                default: 'dwpp-last-page',
            },
        },


        // Main editor function
        edit: props => {

            return [

                // Sidebar controls
                <Fragment>
                    <InspectorControls>
                        <PanelBody title={'View'} initialOpen={true}>
                            <PanelRow>
                                <TextControl
                                    label={ __('Login text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.loginText }
                                    onChange={ value => props.setAttributes({ loginText: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <TextControl
                                    label={ __('Logout text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.logoutText }
                                    onChange={ value => props.setAttributes({ logoutText: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Style', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ styling: value }) }
                                    options={[
                                        { value: 'no', label: __('None', 'discord-wordpress-plugin') },
                                        { value: 'default', label: __('Default', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.styling }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Redirect to', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ redirectTo: value }) }
                                    options={[
                                        { value: 'dwpp-last-page', label: __('Last page', 'discord-wordpress-plugin') },
                                        { value: 'dwpp-prev-page', label: __('Previous page', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.redirectTo }/>
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>,

                // Output in editor
                <a className={"dwpp__authorization dwpp__button--" + props.attributes.styling + "-style"} href="javascript:void(0)">
                    { props.attributes.logoutText }
                </a>
            ];
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
